export const PROJECTS_CARD_DESCRIPTION =
  "Let employees map expenses to a specific project.";

export const PROJECTS_TABLE_HEADERS = [
  "Project code",
  "Project name",
  "Status",
];
